import React, { useEffect, useRef, useState } from "react";
import "./scss/Storefront.scss";
import Layout from "../../components/Layout";
import { Container, Col, Row, Card, Button, Spinner, Modal} from "react-bootstrap";
import formatCurrency from "../../utils/currencyFormmter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createOrder, getStoreProducts, updateMerchantDetails } from "../../redux/slices/inventory.slice";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, clearCart, removeFromCart, initializeCartSession} from "../../redux/slices/cartSlice.slice";
import Swal from "sweetalert2";
import FloatingCart from "../../components/FloatingCart";
import Cart from "../../components/Cart";
import InventoryConnectionButton from "../../components/InventoryConnector";
import InventoryConnection from "../../components/InventoryConnection";
import { QRCodeSVG } from "qrcode.react";
import toast from "react-hot-toast";
import shortenText from "../../utils/shortenText";
import { set } from "lodash";

const Storefront = () => {

  const isLoaded = useRef(false);
  const dispatch = useDispatch();
  const { items: cart } = useSelector((state) => state.cart);
  const { business = {} } = useSelector((state) => state.user)
  const { inventoryRef = "", invLogin, merchant = {} } = useSelector((state) => state.inventory)

  useEffect(() => {
    dispatch(initializeCartSession());
  }, [dispatch]);

  const initialState = {
    products: [],
    loading: false,
    payload: {
      sortBy: "desc"
    },
    sending: false,
    printReceipt: false,
    orderNumber: "",
    showLink: false,
    link: "",
    showWhatsappForm: false,
    sendingRequest: false,
    merchant: merchant
  }

  const [state, setState] = useState(initialState)
  const totalPrice = cart.reduce((sum, item) => sum + (item.sales_price * item.quantity), 0)

  useEffect(() => {
    if (invLogin && !isLoaded.current) {
      loadProducts();
      isLoaded.current = true;
    }
  }, [invLogin]);

  const loadProducts = () => {
    setState((prevState) => ({...prevState, loading: true}))
    dispatch(getStoreProducts(state.payload))
    .then((response) => {
      if(response.payload.status && response.payload.status === true) {
        setState((prevState) => ({...prevState, products: response.payload?.data?.data}))
      }
    })
    .catch((error) => {
      console.error('Error fetching data: ', error);
    })
    .finally(() => setState((prevState) => ({...prevState, loading: false})))
  }

  const checkout = () => {
    Swal.fire({
      icon: "warning",
      text: "Are you sure to place this order?",
      showCancelButton: true,
      showConfirmButton: true,
    })
    .then((result) => {
      if(result.isConfirmed) {
        placeOrder()
      }
    })
  }

  const placeOrder  = () => {
    let requestPayload = {
      items: cart,
      orderTotal: totalPrice,
      payment_method: state.payload.payment_method,
      notes: state.payload.notes
    }

    setState((prevState) => ({...prevState, sending: true}))
    dispatch(createOrder(requestPayload))
    .then((response) => {
      if(response.payload?.status === true) {
        setState((prevState) => ({...prevState, orderNumber: response.payload?.data?.order_number}))
        Swal.fire({
          icon: 'success',
          text: 'Order placed successfully'
        })
        .then(() => setState((prevState) => ({...prevState, printReceipt: true })))
      }
      else {
        Swal.fire({
          icon: 'error',
          text: response.payload?.message
        })
      }
    })
    .finally(() => setState((prevState) => ({...prevState, sending: false})))
  }

  const handleAddToCart = (product) => {
    dispatch(addToCart(product));
  };
 
  const handleRemoveFromCart = (id) => {
    dispatch(removeFromCart(id));
  };

  const handleClear = () => {
    dispatch(clearCart());
    setState((prevState) => ({...prevState, printReceipt: false}))
  };

  const isProductInCart = (id) => {
    return cart.some((item) => item.id === id);
  };

  const serverSideSearch = (event) => {
    const value = event.target.value;
    let requestPayload = state.payload
    state.payload.filter = value

    if (value.length >= 3) {
      setState((prevState) => ({...prevState, loading: true}))
      dispatch(getStoreProducts(state.payload))
      .then((response) => {
        const result = response.payload?.data?.data
        if(result !== null && result !== undefined) {
            setState((prevState) => ({...prevState, products: result}))
        }
        else {
          setState((prevState) => ({...prevState, products: []}))
        }
      })
      .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }
    else if (value.length === 0) {
      loadProducts()
    }
  }

  const sortProducts = (order) => {
    setState((prevState) => ({...prevState, payload: {...prevState.payload, sortBy: order}}))
    loadProducts()
  }

  const handleInput = (event) => {
    const {name, value} = event.target
    setState((prevState) => ({...prevState, payload: {...prevState.payload, [name]: value}}))
  }


  const generateStoreLink = () => {
    setState((prevState) => ({...prevState, link: `${window.location.origin}/marketplace/${inventoryRef}`, showLink: !state.showLink}))
  }

  const handleCopy = (copyText) => {
    navigator.clipboard.writeText(copyText)
    .then(() => {
        toast.success(`Copied!`, {  
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,                       
        });
    })
  }

  const updateWhatsappNumber = () => {
    if(!state.payload.whatsapp_phone_number) {
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'Please enter a valid Whatsapp number'
       }); 
       return
    }

    Swal.fire({
      title: 'Confirm Update',
      text: `Are you sure you want to update the Whatsapp number to ${state.payload.whatsapp_phone_number}?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, update it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.isConfirmed) { 
        setState((prevState) => ({...prevState, sendingRequest: true}))
        dispatch(updateMerchantDetails({ whatsapp_phone_number: state.payload.whatsapp_phone_number }))
        .then((response) => {
          if(response.payload?.status === true) {
            Swal.fire({
              title: 'Success',
              icon: 'success',
              text: 'Whatsapp number updated successfully'
             }); 
              setState((prevState) => ({
                ...prevState, 
                merchant: {
                  ...prevState.merchant, 
                  whatsapp_phone_number: state.payload.whatsapp_phone_number
                }, 
                showWhatsappForm: false, 
                payload: {
                  ...prevState.payload, 
                  whatsapp_phone_number: ""
                }
              }))
          }
          else {
            Swal.fire({
              title: 'Error',
              icon: 'error',
              text: response.payload?.message || 'Failed to update Whatsapp number'
             }); 
          }
        })
        .catch((error) => {
          Swal.fire({
            title: 'Error',
            icon: 'error',
            text: error.message || 'An error occurred while updating Whatsapp number'
           }); 
        })
        .finally(() => setState((prevState) => ({...prevState, sendingRequest: false})))
      }
    })
  };


  return (
    <Layout>
      <Container fluid className="mt-4">
        <InventoryConnectionButton />
        {/* <InventoryConnection /> */}
        <Col md={12} lg={12} className="d-flex justify-content-between align-items-center">
          <Col md={8} className="product-search">
            <div className="input-group">
                <button 
                    type="button" 
                    className="input-group-text"
                >
                    <FontAwesomeIcon icon={"search"} style={{fontSize: "20px"}}/>
                </button>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    onKeyUp={serverSideSearch}
                />
                  <div className="input-group-text d-flex px-1">
                    <button 
                      type="button" 
                      className={`btn-plain ${state.payload.sortBy === 'desc' ? "bg-primary text-white rounded" : ""} `}
                      onClick={() => sortProducts("desc")}
                    >
                      <FontAwesomeIcon icon={'arrow-up-short-wide'} />
                    </button>
                    <button 
                      type="button" 
                      className={`btn-plain ms-2 ${state.payload.sortBy === 'asc' ? "bg-primary text-white rounded" : ""} `}
                      onClick={() => sortProducts("asc")}
                    >
                      <FontAwesomeIcon icon={'arrow-down-short-wide'} />
                    </button>
                  </div>
            </div>
          </Col>
          <div>
            <Button type="button" variant="primary" onClick={() => setState((prevState) => ({...prevState, showWhatsappForm: !state.showWhatsappForm}))} className="me-2">
              <FontAwesomeIcon icon={"fab fa-whatsapp"} style={{fontSize: "20px"}}/> Whatsapp Number
            </Button>
            <Button type="button" variant="primary" onClick={generateStoreLink}>
              <FontAwesomeIcon icon={"link"} style={{fontSize: "20px"}}/> Generate Store Link
            </Button>
          </div>
        </Col>
        <Row>
          <Col md={8} className="product-grid no-print">
            <p className="text-center mt-3 text-primary">
              { state.loading && <Spinner size="sm" /> }
            </p>
            <Row xs={1} md={2} lg={3} className="g-4">
              {state.products.map((product) => (
                <Col key={product.id}>
                  <Card 
                    className={`h-100 border-0 single-product`} 
                    onClick={() => !isProductInCart(product.id) ? handleAddToCart(product) : null}
                    style={{ overflow: 'hidden' }}
                  >
                    <div 
                      className="d-flex justify-content-center align-items-center" 
                      style={{
                        height: '200px', 
                        overflow: 'hidden',
                        backgroundColor: '#ffffff'
                      }}
                    >
                      <Card.Img 
                        variant="top" 
                        src={product.image} 
                        style={{
                          objectFit: 'contain', 
                          width: 'auto',
                          maxHeight: '100%',
                          maxWidth: '100%'
                        }}
                        className="mx-auto" 
                        onError={(e) => {
                          e.target.src = 'https://placehold.co/400x400'; 
                        }}
                      />
                    </div>
                    
                    <Card.Body className="d-flex flex-column">
                      <Card.Title className="text-center mb-2">{product.name}</Card.Title>
                      <Card.Text className="text-center text-primary fw-bold">
                        {formatCurrency(product.sales_price).with_currency}
                      </Card.Text>
                      <Card.Text className="text-center text-muted" style={{ fontSize: '14px', flexGrow: 1 }}>
                        {product.description ? shortenText(product.description, 150) : "No description available."}
                      </Card.Text>
                    </Card.Body>
                    
                    <Card.Footer className="bg-white border-0 pt-0">
                      <Button 
                        variant={isProductInCart(product.id) ? "success" : "primary"}
                        className="w-100"
                        onClick={(e) => {
                          e.stopPropagation();
                          isProductInCart(product.id) 
                            ? handleRemoveFromCart(product.id) 
                            : handleAddToCart(product);
                        }}
                      >
                        {isProductInCart(product.id) ? "Added to Cart" : "Add to Cart"}
                      </Button>
                    </Card.Footer>
                  </Card>
                </Col>
              ))}
            </Row>
              {
                state.products.length === 0 && <Col md={12} className="text-center mt-5">No items available</Col>
              }
          </Col>

          <Col md={4} sm={12} className="cart mt-5 storefront-cart">
            <Cart 
              cartItems={cart}
              handleSubmit={checkout}
              requestStatus={state.sending}
              printReceipt={state.printReceipt}
              clearCart={handleClear}
              handleInput={handleInput}
              orderNumber={state.orderNumber}
            />
            <FloatingCart>
              <Cart 
                cartItems={cart}
                handleSubmit={checkout}
                requestStatus={state.sending}
                printReceipt={state.printReceipt}
                clearCart={handleClear}
                handleInput={handleInput}
                orderNumber={state.orderNumber}
              />
            </FloatingCart>
          </Col>
        </Row>
        <Modal 
          show={state.showLink}
          onHide={() => setState((prevState) => ({...prevState, showLink: false}))}
          backdrop="static"
        >
          <Modal.Header closeButton className="border-0 bg-primary text-white p-1 px-2">
              <Modal.Title as="h5"> {business?.store_name} Store Link </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="bg-light qr-img p-4 text-center rounded-16">
              <QRCodeSVG value={state.link} size={300} />
              <div className="bg-white custom-bordered d-flex align-items-center justify-content-between p-2 mb-3 mt-3">
                <span>{state.link}</span>
                <Button 
                    type="button" 
                    variant="light" 
                    className="bg-white text-primary border-0" 
                    onClick={ ()  => handleCopy(state.link) }
                >
                    <FontAwesomeIcon icon="far fa-copy" style={{fontSize: "27px"}}/>
                </Button>
              </div>
              <a href={state.link} className="btn btn-primary" target="_blank">Visit Shop</a>
            </div>
          </Modal.Body>
          <Modal.Footer className="p-1 px-2">
            <Button 
              type="button" 
              variant="danger" 
              className="text-white"
              onClick={() => setState((prevState) => ({...prevState, showLink: false}))}
            >Close</Button>
          </Modal.Footer>
        </Modal>

        {/* Whatsapp phone number update form */}
        <Modal 
          show={state.showWhatsappForm}
          onHide={() => setState((prevState) => ({...prevState, showWhatsappForm: false}))}
          backdrop="static"
        >
          <Modal.Header closeButton className="border-0 bg-primary text-white p-1 px-2">
              <Modal.Title as="h5"> Whatsapp Number Management </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="bg-lightd p-4 text-center rounded-16">
              <Row className="mb-3">
                <Col md={9} className="offset-md-2d">
                  <input 
                    type="tel" 
                    className="form-control" 
                    placeholder="Enter Whatsapp Number" 
                    name="whatsapp_phone_number"
                    value={state.payload.whatsapp_phone_number || ""}
                    onChange={handleInput}
                    minLength={11}
                    maxLength={11}
                  />
                </Col>
                <Col md={3} className="d-grid">
                  <Button 
                    type="button" 
                    variant="primary" 
                    onClick={updateWhatsappNumber}
                    disabled={state.sendingRequest}
                  >
                    Update <Spinner size="sm" className="ms-2" style={{ display: state.sendingRequest ? 'inline-block' : 'none' }} />
                  </Button>
                </Col>  
              </Row>
              <p className="text-primary">Current Whatsapp Number: {state.merchant?.whatsapp_phone_number || "Not provided"}</p>
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </Layout>
  );
};

export default Storefront;